<script setup>
import { ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";

import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiClipboardEdit,
    mdiClose,
    mdiBroom,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array
    //connstantes: Array

})

const showTest = ref(false)

// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)


// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

//produtos nuevos ORDER BY created_at LIMIT 8
const productosNuevos = ref(null)
productosNuevos.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
]

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcasRelacionadas = ref(null)
marcasRelacionadas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]

// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

</script>

<!-- <script>

import { GoogleMap, Marker } from "vue3-google-map";

const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg";

export default {
  name: "App",
  components: { GoogleMap, Marker },
  data() {
    const center = { lat: 40.689247, lng: -111.044502 };
    return { center, YOUR_GOOGLE_MAPS_API_KEY };
  },
};

</script> -->






<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->



<template>
    <SeoMeta />
    <BreezeGuestLayout>
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/order/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Area de Pedido</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Pedido</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->
        <!-- START AREA DE CONTACTO -->

        <section>
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:pt-16">
                <div class="grid grid-cols-1 gap-16">
                    <div class="col-span-1">


                        <div class="tab-card tab-light mb-4">
                            <input id="tab-test" type="checkbox" class="tab-input">
                            <label @click="showTest = !showTest" class="tab-label" for="tab-test">
                                <div class="">
                                    <span class="">
                                        <BaseIcon :path="mdiClipboardEdit" :size="24" class="mr-3" />
                                        Esto es una prueba
                                    </span>
                                </div>
                            </label>
                            <div v-if="showTest" class="tab-content">
                                <div>
                                    test
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->
        <!-- END AREA DE CONTACTO -->


        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->
        <section class="py-8">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que Ofrecemos</h1>
                    </div>
                    <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="relative slider-marcas" v-if="marcasRelacionadas.length > 0">
                    <hr class="my-4">
                    <Splide :has-track="true" :options="{ rewind: 'true', perPage: 6, perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', breakpoints: { 1023: { perPage: 3 }, 640: { perPage: 2, } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md h-full " v-for="(item, index) in marcasRelacionadas" :key="item.id">
                            <div class="rounded-md h-full">
                                <div class="text-white p-6 bottom-0 flex items-end h-full  rounded-md">
                                    <a href="#"><img :src="item.ruta_imagen" class="hover:grayscale"></a>
                                </div>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>
        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->

        <!-- START PRODUCTOS DE CATEGORIA -->
        <!-- START PRODUCTOS DE CATEGORIA -->
        <!-- START PRODUCTOS DE CATEGORIA -->
        <section class="py-8 lg:pt-20">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Productos Relacionados</h1>
                    </div>
                    <div><a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-if="productosNuevos.length > 0" class="section-content">
                    <div class="w-full">
                        <div class="sm:grid-cols-1 xl:col-span-8 h-full">
                            <div class="w-full grid lg:grid-cols-2 xl:grid-cols-3 grid-cols-1 gap-4 h-full">
                                <div class="h-1/3 col-span-1" v-for="(item, index) in productosDestacados" :key="item.id">
                                    <div class="w-full h-[210px] bg-white group relative overflow-hidden rounded-lg shadow-xl shadow-gray-400/10">
                                        <div class="flex space-x-5 items-center w-full h-full lg:p-4">
                                            <div class="lg:w-1/2 w-1/3 h-full">
                                                <img :src="item.ruta_imagen" alt="" class="w-full h-full object-contain">
                                            </div>
                                            <div class="flex-1 flex flex-col justify-center h-full">
                                                <div>
                                                    <div class="flex space-x-1 mb-3">
                                                        <span v-for="i in item.rating">
                                                            <BaseIcon :path="mdiStar" :size="20" class="text-yellow-400" w="w-6" h="h-6"></BaseIcon>
                                                        </span>
                                                    </div>
                                                    <p class="mb-2 sm:text-sm text-xs font-semibold leading-[24px] line-clamp-2 hover:text-blue-600">{{ item.label }}</p>

                                                    <p class="mb-4"><span class="line-through font-600 text-gray-500 text-sm">{{ item.moneda_simb }} {{ item.precio_lista }}</span><span class="font-semibold text-gray-800 text-sm ml-2">{{ item.moneda_simb }} {{ item.precio }}</span>

                                                    </p>
                                                    <button type="button" class="btn btn-color btn-ico flex justify-center">
                                                        <div class="flex items-center space-x-2 md:space-x-0 2xl:space-x-3">
                                                            <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white inline-block md:hidden 2xl:inline-block" w="w-6" h="h-6"></BaseIcon>
                                                            <span>Agregar al carrito</span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- <div class="flex flex-col space-y-2 absolute group-hover:right-4 -right-10 top-[30px]  transition-all duration-300 ease-in-out">
                                            <a href="#">
                                            <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                <BaseIcon :path="mdiArrowExpandAll" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                            </span>
                                            </a><a href="#">
                                                <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                    <BaseIcon :path="mdiHeartOutline" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                                </span>
                                            </a>
                                            <a href="#">
                                                <span class="w-10 h-10 flex justify-center items-center bg-gray-200/50 rounded">
                                                    <BaseIcon :path="mdiRepeat" :size="24" class="icon-color-black" w="w-6" h="h-6"></BaseIcon>
                                                </span>
                                            </a>
                                        </div> -->
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END PRODUCTOS DE CATEGORIA  -->
        <!-- END PRODUCTOS DE CATEGORIA  -->
        <!-- END PRODUCTOS DE CATEGORIA  -->



































        <!-- <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
